import { SalesByCategoryReport } from 'model/SalesByCategoryReport';

export interface SalesByCategoryReportState {
    loading: boolean;
    report: SalesByCategoryReport;
}

export const emptySalesByCategoryReport: SalesByCategoryReport = {
    range: {
        start: '',
        end: ''
    },
    totals: {
        quantity: 0,
        grossSales: 0,
        discounts: 0,
        refunds: 0,
        netSales: 0
    },
    categories: []
};

export const initialSalesByCategoryReportState: SalesByCategoryReportState = {
    loading: false,
    report: emptySalesByCategoryReport
};
